import { pipe } from 'ramda';
import { setAction, setReceivedLabel } from '@creditas-lab/analytics-events';
import { DispatchEvent, dispatchFrontendDashboardEvent } from './commons';

const dispatchAvailableLeadReviewErrorEvent: DispatchEvent = pipe(
  setReceivedLabel,
  setAction('request_get_available_lead_review_error'),
  dispatchFrontendDashboardEvent,
);

const dispatchAvailableLeadReviewSuccessEvent: DispatchEvent = pipe(
  setReceivedLabel,
  setAction('request_get_available_lead_review_success'),
  dispatchFrontendDashboardEvent,
);

export { dispatchAvailableLeadReviewErrorEvent, dispatchAvailableLeadReviewSuccessEvent };
